import axios from '../../plugins/axios';
import { Message } from 'element-ui';

export const products_module = {
    state: ()=>({
        pending: false,
        loadingMore: false,
        data: {
            current_page: 1,
            data: [],
            last_page: null,
            brands:[],
            filter:{
                categories:[],
                category_ids: [],
                type:[],
                status:[],
                brands:[],
                brand_ids: [],
                tags:[],
                featured:[],
                indexed:[],
                searchedTerm:'',
            },
            allFilters:[],
        },
        message: null,
        success: null,
        error: null
    }),
    mutations: {
        fetch_products_request(state, loadingType){

            if(loadingType == 'new'){

                state.pending = true;

            }else if(loadingType == 'more'){

                state.loadingMore = true;

            }

        },
        fetch_products_success(state, payload){

            if(payload.loadData == 'new'){

                state.data.data = payload.products.data.map(product=>{

                    let obj = product;

                    if(obj.seo && obj.seo.keywords){

                        obj.seo.keywords = obj.seo.keywords.map(key=>{

                            return key.keyword

                        });

                    }else{

                        obj.seo ={
                            keywords : []
                        };

                    }

                    obj.tags = obj.tags.map(tag=>{

                        return tag.name

                    });

                    return obj;

                });
    
                payload.products.data.forEach(product => {

                    if(product.brand && !state.data.brands.includes(product.brand)){

                        state.data.brands.push(product.brand);

                    }

                });

            }

            if(payload.loadData == 'more'){
                
                let moreProducts = payload.products.data.map(product=>{

                    let obj = product;

                    if(obj.seo && obj.seo.keywords){

                        obj.seo.keywords = obj.seo.keywords.map(key=>{

                            return key.keyword

                        });

                    }else{

                        obj.seo = {
                            keywords : []
                        };

                    }

                    obj.tags = obj.tags.map(tag=>{

                        return tag.name

                    });

                    return obj;

                });

                moreProducts.forEach(element => {

                    state.data.data.push(element);

                });
                
                payload.products.data.forEach(product => {

                    if(product.brand && !state.data.brands.includes(product.brand)){

                        state.data.brands.push(product.brand);

                    }

                });

            }

            state.data.current_page = payload.products.current_page;
            state.data.last_page = payload.products.last_page;
            state.pending = false;
            state.loadingMore = false;
            state.success = true;
            state.error = null;
            state.message = payload.message;

        },
        fetch_products_failure(state, payload){

            state.data.data = [];
            state.pending = false;
            state.loadingMore = false;
            state.success = false;
            state.error = payload.error;
            state.message = payload.message;

        },
        add_products_list(state,payload){

            payload.tags = payload.tags.map(tag=>{

                return tag.name;

            });

            state.data.data.unshift(payload);

        },
        update_products_list(state,payload){

            let productIndex = state.data.data.findIndex((listedProduct) => listedProduct.id == payload.updatedProduct.id);

            if(productIndex != -1){

                payload.updatedProduct.tags = payload.updatedProduct.tags.map(tag=>{

                    return tag.name
    
                });
    
                state.data.data[productIndex] = payload.updatedProduct;

            }

            // if(state.data.filter.type.length != 0){

            //     if(state.data.filter.type[0] != payload.updatedProduct.product_type){

            //         state.data.data = state.data.data.filter((product) => product.id != payload.updatedProduct.id);

            //     }

            // }

        },
        find_and_update_product(state,payload){

            let index = state.data.data.findIndex((dataItem) => dataItem.id == payload.product.id);

            if(index != -1){

                payload.product.tags = payload.product.tags.map(tag=>{

                    return tag.name
    
                });

                state.data.data[index] = payload.product

            }

        },
        update_product_status(state,payload){

            state.data.data[payload.index].isActive = payload.updatedProduct.isActive;

            if(state.data.filter.status != 0){

                if((state.data.filter.status[0] == 'hide') && (payload.updatedProduct.isActive == 1) || 
                (state.data.filter.status[0] == 'active') && (payload.updatedProduct.isActive == 0)){

                    state.data.data = state.data.data.filter((product) => product.id != payload.updatedProduct.id);

                }

            }

        },
        delete_products_list(state,payload){

            state.data.data.splice(payload,1);

        },
        products_bulk_action(state,payload){

            if(payload.action == 'isFeatured'){

                state.data.data = state.data.data.filter((product)=>{

                    if(payload.listIds.includes(product.id)){

                        product.isFeatured = payload.selection

                        return product

                    }else{

                        return product
                        
                    }

                });

            }else if(payload.action == 'delete'){

                state.data.data = state.data.data.filter((product)=>{

                    if(!payload.listIds.includes(product.id)){

                        return product
                        
                    }

                });

            }else if(payload.action == 'statusChange'){

                state.data.data = state.data.data.filter((product)=>{

                    if(payload.listIds.includes(product.id)){

                        product.isActive = payload.status

                        return product

                    }else{

                        return product

                    }

                });

            }

        },
        delete_product_tag(state,payload){

            state.data.data[payload.pIndex].tags.splice(state.data.data[payload.pIndex].tags.indexOf(payload.tagName),1)

        },
        update_product_review_status(state,payload){

            state.data.data[payload.product_index].reviews[payload.review_index] = payload.review

        },
        update_product_filters(state,payload){

            state.data.filter.categories = payload.categories
            state.data.filter.category_ids = payload.category_ids
            state.data.filter.type = payload.type
            state.data.filter.status = payload.status
            state.data.filter.brands = payload.brands
            state.data.filter.brand_ids = payload.brand_ids
            state.data.filter.tags = payload.tags
            state.data.filter.featured = payload.featured
            state.data.filter.indexed = payload.indexed

            // state.data.filter.searchedTerm = payload.searchedTerm

        },
        update_product_allFilters(state,payload){

            state.data.allFilters = payload

        },
        remove_product_filters(state){

            state.data.filter.categories = []
            state.data.filter.category_ids = []
            state.data.filter.type = []
            state.data.filter.status = []
            state.data.filter.brands = []
            state.data.filter.brand_ids = []
            state.data.filter.tags = []
            state.data.filter.featured = []
            state.data.filter.indexed = []

            state.data.allFilters = []
            
        },
        update_searched_keyword(state,payload){

            state.data.filter.searchedTerm = payload.keyword

        },
        remove_product_search(state){

            state.data.filter.searchedTerm = ''

            state.data.allFilters = []

        },
        CLEAR_MODULE(state){

            state.pending = false
            state.loadingMore = false;
            state.message = null
            state.success = null
            state.error = null

            state.data.current_page = 1
            state.data.data = []
            state.data.last_page = null
            state.data.brands = []
            state.data.filter = {
                categories:[],
                category_ids:[],
                type:[],
                status:[],
                brands:[],
                brand_ids:[],
                tags:[],
                searchedTerm:'',
                featured:[],
                indexed:[],
            }
            state.data.allFilters = []
            
        }
    },
    actions:{
        async fetchStoreProductsRequest({commit},{size, page, loadData}){

            let category_ids = this.state.products_module.data.filter.category_ids;
            let brand_ids = this.state.products_module.data.filter.brand_ids;
            let tags = this.state.products_module.data.filter.tags;
            let type = this.state.products_module.data.filter.type;
            let status = this.state.products_module.data.filter.status;
            let searchedTerm = this.state.products_module.data.filter.searchedTerm;
            let featured = this.state.products_module.data.filter.featured[0];
            let indexed = this.state.products_module.data.filter.indexed[0];
            
            commit('fetch_products_request',loadData);
            try{
                let res = await axios.get(`/getProducts`,{
                    params:{
                        categories: category_ids,
                        brands: brand_ids,
                        tags: tags,
                        type: type[0],
                        status: status[0],
                        search: searchedTerm.length > 0 ? searchedTerm : null,
                        featured: featured ? featured == 'featured' ? true : false : null,
                        indexed: indexed ? indexed == 'indexed' ? 1 : 0 : null,
                        offset: size,
                        page: page,
                    }
                });
                if(res.data.status_code == '1007'){

                    res.data.loadData = loadData

                    commit('fetch_products_success', res.data);

                }
            }catch(ex){

                Message({
                    type: 'error',
                    showClose: true,
                    message: ex.response ? ex.response.data.message : ex.message,
                });

                commit('fetch_products_failure', {error: ex, message: ex});

            }

        }
    },
    getters: {
        products(state){

            return state.data.data;

        },
        brands(state){

            return state.data.brands;

        },
        searchedTerm(state){

            return state.data.filter.searchedTerm

        },
        filters(state){

            return state.data.filter;

        },
        allFilters(state){

            return state.data.allFilters;

        },
        currentPage(state){

            return state.data.current_page;

        },
        lastPage(state){

            return state.data.last_page;

        },
        isPending(state){

            return state.pending;

        },
        isLoadingMore(state){

            return state.loadingMore;

        },
        message(state){

            return state.message;
            
        },
        error:(state)=>state.error
    }
}